export var VERSION = '2.18.2';
//# sourceMappingURL=version.js.map